import type { MouseEvent } from 'react';

import classNames from 'classnames';

import { ExternalLink } from '@uikit/components/ExternalLink';

import useCheckRequiredSelfData from '@shared/hooks/useCheckRequiredSelfData';

export const JoinCampaignButton = ({
  className,
  campaignUrl,
}: {
  className?: string;
  campaignUrl: string;
}) => {
  const { check, isAuth } = useCheckRequiredSelfData();

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    if (!check({ auth: true })) {
      event.preventDefault();

      return;
    }
  };

  return (
    <ExternalLink
      href={isAuth ? campaignUrl : '#'}
      onClick={handleClick}
      className={classNames('button button-solid-secondary button-md md:button-xl', className)}
    >
      Join the Campaign Now
    </ExternalLink>
  );
};
